/**
 * 全局混合
 */
import { Vue, Component } from 'vue-property-decorator';
import { Getter, namespace } from 'vuex-class';
const LoginGetter = namespace('login', Getter);

@Component
export default class Auth extends Vue {
  @LoginGetter('authList')
  private authList: any;
  // 校验是否有对应的权限
  public hasAuth(auth: string) {
    return this.authList.some((val: string) => {
      return val === auth;
    });
  }
}
